import React, { useState } from "react";
import Menubinder from "../menu";
import RemitosAnulados from "../remitosAnulados";

function VerRemitosAnulados() {
  const [menuOpen, setMenuOpen] = useState(true);
  const sidebarWidth = menuOpen ? 220 : 64;

  return (
    <div
      className="ingreso-layout"
      style={{ display: "flex", minHeight: "100vh", background: "#0c1f1d" }}
    >
      <Menubinder
        defaultOpen={menuOpen}
        onToggle={(next) => setMenuOpen(next)}
      />

      <main
        className="contenido-panel"
        style={{
          marginLeft: sidebarWidth,
          width: `calc(100% - ${sidebarWidth}px)`,
          minWidth: 0,
          transition: "margin-left .25s ease, width .25s ease",
          padding: 20,
          background:
            "radial-gradient(900px 600px at -10% -10%, #183c34 0%, transparent 45%), #0c1f1d",
        }}
      >
        <RemitosAnulados />
      </main>
    </div>
  );
}

export default VerRemitosAnulados;
